module.exports = __webpack_public_path__ + "img/VIDEO_2x.ed8a779f.svg";